// extracted by mini-css-extract-plugin
export default {"Link":"Link_Link__FztcI","Link_Large":"Link_Link_Large__5Qgmk"};